import { ApiCommunications } from '../../webmodule-common/interop/interfaces/api-communications';
import { PaymentProfileApi } from './payment-profile-api';
import { NullPromise } from '../../webmodule-common/interop/types/misc';
import {
  InputCreatePaymentProfile,
  InputDeletePaymentProfile,
  InputUpdatePaymentProfile,
  RequestBrowsePaymentProfileSummary,
  RequestGetClientDefaultPaymentProfileListByIds,
  RequestGetClientDefaultPaymentType,
  RequestGetPaymentProfile,
  ResultBrowsePaymentProfileSummary,
  ResultCreatePaymentProfile,
  ResultDeletePaymentProfile,
  ResultGetClientDefaultPaymentProfileListByIds,
  ResultGetClientDefaultPaymentType,
  ResultGetPaymentProfile,
  ResultUpdatePaymentProfile
} from './dealer-api-interface-franchisee';

export class PaymentProfileApiImplementation implements PaymentProfileApi {
  private readonly api: ApiCommunications;
  private readonly baseRoute = 'api/Franchisee/';

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  private post<T>(endpoint: string, body: unknown): NullPromise<T> {
    return this.api.post<T>(`${this.baseRoute}${endpoint}`, body);
  }

  async browsePaymentProfileSummary(
    body: RequestBrowsePaymentProfileSummary
  ): NullPromise<ResultBrowsePaymentProfileSummary> {
    return this.post<ResultBrowsePaymentProfileSummary>('BrowsePaymentProfileSummary', body);
  }

  async createPaymentProfile(body: InputCreatePaymentProfile): NullPromise<ResultCreatePaymentProfile> {
    return this.post<ResultCreatePaymentProfile>('CreatePaymentProfile', body);
  }

  async deletePaymentProfile(body: InputDeletePaymentProfile): NullPromise<ResultDeletePaymentProfile> {
    return this.post<ResultDeletePaymentProfile>('DeletePaymentProfile', body);
  }

  async getClientDefaultPaymentProfileListByIds(
    body: RequestGetClientDefaultPaymentProfileListByIds
  ): NullPromise<ResultGetClientDefaultPaymentProfileListByIds> {
    return this.post<ResultGetClientDefaultPaymentProfileListByIds>('GetClientDefaultPaymentProfileListByIds', body);
  }

  async getClientsDefaultPaymentProfile(
    body: RequestGetClientDefaultPaymentType
  ): NullPromise<ResultGetClientDefaultPaymentType> {
    return this.post<ResultGetClientDefaultPaymentType>('GetClientsDefaultPaymentProfile', body);
  }

  async getPaymentProfile(body: RequestGetPaymentProfile): NullPromise<ResultGetPaymentProfile> {
    return this.post<ResultGetPaymentProfile>('GetPaymentProfile', body);
  }

  async updatePaymentProfile(body: InputUpdatePaymentProfile): NullPromise<ResultUpdatePaymentProfile> {
    return this.post<ResultUpdatePaymentProfile>('UpdatePaymentProfile', body);
  }
}


